<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="grupe">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            class="tooltip-tab"
            v-for="item in grupes"
            :key="`tooltipgrupe${item.value}`"
          >
            <h4>{{ item.text }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <admin-tooltip-detail :grupe="grupeValue" :key="`tooltipdetail${grupe}`" />
  </v-container>
</template>

<script>
import AdminTooltipDetail from './AdminTooltipDetail'

export default {
  name: 'AdminTooltip',
  components: { AdminTooltipDetail },
  data() {
    return {
      grupe: 0,
    }
  },
  computed: {
    grupes() {
      return [
        {
          text: 'NTR/STSR patartys (tooltips)',
          value: 'ntr_stsr',
        },
        {
          text: 'Aprašymai',
          value: 'aprasymas',
        },
        {
          text: 'NEP patartys (tooltips)',
          value: 'ntrpaslaugos',
        },
      ]
    },
    grupeValue() {
      return this.grupes[this.grupe].value
    },
  },
}
</script>
